import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { Formik } from "formik";
import { Autocomplete, Divider, FormLabel, Grid, TextField } from "@mui/material";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";
import { useControlVerificationStore } from "../../hooks/useControlVerificationStore";
import { useControlCategoryStore } from "../../hooks/useControlCategoryStore";
import { ControlVerificationCategory } from "../../types/slices/controlVerificationCategoryType";

type ControlVerificationFormData ={
    name:string
    idcategory_control:number
}

export const ControlVerificationForm:FC = () => {
    const navigate = useNavigate()
    const { status, editControlVerification, createControlVerification, updateControlVerification } = useControlVerificationStore()
    const { status: statusCategory, controlVerificationsCategory, getControlsCategories } = useControlCategoryStore()

    const [selectedCategory, setSelectedCategory] = useState<ControlVerificationCategory|null>(null)
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [data, setData] = useState<ControlVerificationFormData>({
        name: '',
        idcategory_control: 1
    })

    useEffect(() => {
        getComboBoxes()
        if (Object.entries(editControlVerification).length > 0) {
            setIsEdit(true)
            setData({
                name: editControlVerification.name,
                idcategory_control: editControlVerification.idcategory_control
            })
        }
    }, [])

    useEffect(()=>{
        if (Object.entries(editControlVerification).length > 0 && controlVerificationsCategory.length > 0) {
            const category = controlVerificationsCategory?.find(category => category.id === editControlVerification.idcategory_control)
            setSelectedCategory(category||null)
        }
    },[controlVerificationsCategory])

    const getComboBoxes = async () => {
        await getControlsCategories()
    }

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.name) errors.name = "Descripción es requerido";
        if (!values.idcategory_control) errors.idcategory_control = "Categoría es requerido";
        return errors;
    }

    const onSubmit = async (values) => {
        const payload = {
            name: values.name,
            idcategory_control: values.idcategory_control
        }
        const method = !isEdit ? createControlVerification(payload) : updateControlVerification(editControlVerification.id, payload)
        const response = await method
        if (response === true) navigate({ pathname: RoutesMap.CONTROL_VERIFICATION_LIST })  
    }

    const onCancel = async () => {
        navigate({ pathname: RoutesMap.CONTROL_VERIFICATION_LIST })
    }

    return(
        <CustomForm>
            {status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            {statusCategory === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <CustomFormHeader
                title={!isEdit ? 'Nuevo control' : 'Editar control'}
                text={!isEdit ? 'Ingrese los datos del nuevo control' : 'Ingrese los datos del control'}
                goBack={RoutesMap.CONTROL_VERIFICATION_LIST}
            />
            <CustomFormBody>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2} sx={{ mt: 2 }}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text"
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Categoría:</FormLabel>
                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-category"
                                                value={selectedCategory}
                                                options={controlVerificationsCategory || []}
                                                getOptionLabel={(option) => option.name_category || ""}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} size="small" />}
                                                onChange={(e, newValue) => {
                                                    setSelectedCategory(newValue)
                                                    setFieldValue('idcategory_control', newValue?.id || 0)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider/>
                                <CustomFormFooter
                                    buttonType="submit"
                                    confirmText={!isEdit ? 'Guardar' : 'Actualizar'}
                                    cancelText={"Cancelar"}
                                    onConfirm={handleSubmit}
                                    onCancel={onCancel}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </CustomFormBody>
        </CustomForm>
    )
}